<template>
  <div class="l-container--width-80">
    <h1
      :class="{
        'c-text--mobile-h1': $vuetify.display.mobile,
        'mb-4': true,
        'text-left': $vuetify.display.mobile,
      }"
    >
      Terms of Use
    </h1>
    <p class="text-left">
      If a User performs a self-assessment evaluation utilizing MITRE ATT&CK®, a User agrees to
      prominently display on any public release that such evaluation was self-performed, crediting
      the ATT&CK Evaluation content used to perform the evaluation, but not infer that MITRE
      conducted the evaluation.
    </p>
    <p class="text-left">
      Whether the evaluation is self-performed or conducted by MITRE, a User shall not
      make a claim that the evaluation shows a User “won” or words of a similar parlance a MITRE
      ATT&CK Evaluation.
    </p>
    <p class="text-left">
      A User shall always provide notice on any internal/external evaluation results publication
      that the evaluation was conducted utilizing the data from the MITRE ATT&CK Evaluations.
    </p>
    <p class="text-left">
      Permission to utilize MITRE ATT&CK Evaluation methodologies and tools for conducting
      evaluations is strictly limited to a User’s self-assessment usage and/or evaluations conducted
      by MITRE.
    </p>
    <p class="text-left">
      Except as otherwise stated above or modified in the MITRE ATT&CK® Evaluation website
      Privacy Policy, the terms of use for this Site is governed by the MITRE Terms &
      Conditions. Please see
      <a href="https://www.mitre.org/terms"
        >https://www.mitre.org/terms</a
      >.
    </p>
  </div>
</template>

<script>
export default {
  name: 'TermsOfUse',
};
</script>
